/**
 * Creates a factory that ensures only one promise is in-flight at a time.
 * If multiple calls are made while a request is pending, they all receive the same promise.
 * Once resolved/rejected, the next call creates a new promise.
 */
export const singleRequestPromiseFactory = <T>(promiseFn: () => Promise<T>): { promise: () => Promise<T> } => {
  let inFlightPromise: Promise<T> | null = null

  return {
    promise: (): Promise<T> => {
      if (inFlightPromise) {
        return inFlightPromise
      }

      inFlightPromise = promiseFn()
        .then((result) => {
          inFlightPromise = null
          return result
        })
        .catch((error) => {
          inFlightPromise = null
          throw error
        })

      return inFlightPromise
    },
  }
}
